import { codeSplit } from 'bernie-core';

export const V3ArticlePillLabelVariationMap = codeSplit(
  () =>
    import(
      /* webpackChunkName: "V3ArticlePillLbelVariationMap" */ '../components/v3-article-pill-label-variation'
    ) as any,
);
